import React, { useState } from "react";
import "./Home.css";
import FeedbackSlider from "../Components/FeedbackSlider";
import SchoolIcon from '@mui/icons-material/School';
import RealEstateAgentIcon from '@mui/icons-material/RealEstateAgent';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();

    const sliders = [
        { img: "/images/bg-slider.jpg", head: 'Let’s take a perfect step for Study Abroad Loans' },
        { img: "/images/bg-slider-1.jpg", head: 'Let’s take a perfect step for Study Abroad Loans' },
        { img: "/images/bg-slider.jpg", head: 'Let’s take a perfect step for Study Abroad Loans' }
    ];
    const cards = [
        { img: "/images/edu.png", head: 'Abroad Education Loans' },
        { img: "/images/study-abrod-icon.png", head: 'Study Abroad Scholarship' },
        { img: "/images/join-community-icon.png", head: 'Join Student Community' },
        { img: "/images/edu.png", head: 'Education Loan' }
    ];
    const courses = [
        { img: "/images/study-abroad-img03.jpg", head: 'Courses' },
        { img: "/images/study-abroad-img04.jpg", head: 'Exam' },
        { img: "/images/study-abroad-img01.jpg", head: 'Overview' },
        { img: "/images/study-abroad.jpg", head: 'Countries' }
    ]
    const blogs = [
        { img: "images/blog.jpg", head: "Unraveling Internship Process in the US: Overcoming Obstacles and Exploring Tech Opportunities in San Francisco", des: "Credere Finance provides personal insights from Suresh, an international student studying MS in CS in the US, on how to find internships in the US." },
        { img: "images/blog.jpg", head: "A Comprehensive Guide for International Students on Securing Internships in the US", des: "Welcome to our complete guide designed specifically for individuals who are ready to pursue internships abroad. Navigating the procedure of finding internships in a foreign nation......" },
        { img: "images/blog.jpg", head: "Academic Pursuits and Beyond: A Student's Experience at Michigan State University", des: "As the first light of dawn softly filters through my window each morning, I am stirred by a deep sense of determination. Promptly at 6 AM, I set off on my day, embraced by the assurance......." },
    ]

    const [loanForm, setLoanForm] = useState({
        type: "Check Loan Eligibility",
        name: "",
        email: "",
        city: "",
        phone: "",
        gender: "",
        whatsapp: "",
        altWhatsapp: "",
        admit: "",
        courseYear: "",
        courseMonth: "",
        courseLevel: "",
        courseDegree: "",
        courseName: "",
        TCountry: "",
        college: ""
    });
    const [loanFormStep, setLoanFormStep] = useState(1);
    const [loanFormErrors, setLoanFormErrors] = useState({});
    const [loanFormLoading, setLoanFormLoading] = useState(false);
    const [loanFormSuccess, setLoanFormSuccess] = useState(false);
    const [loanFormError, setLoanFormError] = useState(null);

    const validateLoanForm = () => {
        const errors = {};
        if (!loanForm.name.trim() || !/^[a-zA-Z\s]+$/.test(loanForm.name)) {
            errors.name = "Name is required and should contain only letters and spaces.";
        }
        if (!loanForm.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loanForm.email)) {
            errors.email = "Valid email is required.";
        }
        if (!loanForm.city.trim()) {
            errors.city = "City is required.";
        }
        if (!/^\d{10}$/.test(loanForm.phone)) {
            errors.phone = "Phone must be exactly 10 digits.";
        }
        if (!loanForm.gender) {
            errors.gender = "Gender is required.";
        }
        if (!loanForm.whatsapp) {
            errors.whatsapp = "Whatsapp selection is required.";
        }
        if (loanForm.whatsapp === "No" && !/^\d{10}$/.test(loanForm.altWhatsapp)) {
            errors.altWhatsapp = "Alternate Whatsapp number must be exactly 10 digits.";
        }
        if (!loanForm.admit) {
            errors.admit = "Admit selection is required.";
        }
        if (!loanForm.courseYear) {
            errors.courseYear = "Course start year is required.";
        }
        if (!loanForm.courseMonth) {
            errors.courseMonth = "Course start month is required.";
        }
        if (!loanForm.courseLevel) {
            errors.courseLevel = "Course level is required.";
        }
        if (!loanForm.courseDegree) {
            errors.courseDegree = "Course degree is required.";
        }
        if (!loanForm.courseName.trim()) {
            errors.courseName = "Course name is required.";
        }
        if (!loanForm.TCountry) {
            errors.TCountry = "Country is required.";
        }
        if (!loanForm.college.trim()) {
            errors.college = "College/University is required.";
        }
        return errors;
    };

    const handleLoanFormChange = (e) => {
        const { name, value } = e.target;
        if ((name === "phone" || name === "altWhatsapp") && !/^\d*$/.test(value)) return;
        if (name === "name" && value && !/^[a-zA-Z\s]*$/.test(value)) return;
        setLoanForm((prev) => ({
            ...prev,
            [name]: value
        }));
        setLoanFormErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleLoanFormRadio = (name, value) => {
        setLoanForm((prev) => ({
            ...prev,
            [name]: value
        }));
        setLoanFormErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleLoanFormSubmit = async (e) => {
        e.preventDefault();
        setLoanFormSuccess(false);
        setLoanFormError(null);

        const errors = validateLoanForm();
        setLoanFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoanFormLoading(false);
            return;
        }

        setLoanFormLoading(true);

        try {
            const formBody = new URLSearchParams({
                ...loanForm,
                altWhatsapp: loanForm.whatsapp === "No" ? loanForm.altWhatsapp : ""
            }).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setLoanFormSuccess(true);
            setLoanForm({
                type: "Check Loan Eligibility",
                name: "",
                email: "",
                city: "",
                phone: "",
                gender: "",
                whatsapp: "",
                altWhatsapp: "",
                admit: "",
                courseYear: "",
                courseMonth: "",
                courseLevel: "",
                courseDegree: "",
                courseName: "",
                TCountry: "",
                college: ""
            });
            setLoanFormStep(1);
        } catch (err) {
            setLoanFormError("Failed to submit. Please try again.");
        }

        setLoanFormLoading(false);
    };

    return (
        <>
            <div id="carouselCaptions" className="carousel slide cred-slider" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {sliders.map((slider, idx) => (
                        <div className={`carousel-item${idx === 0 ? ' active' : ''}`} key={idx}>
                            <img src={slider.img} className="d-block w-100" alt="..." />
                            <div className="carousel-caption d-none d-md-block">
                                <h1>{slider.head}</h1>
                                <button
                                    className="partner-btn ms-0 me-3"
                                    onClick={() => {
                                        navigate(`/check-loan-eligibility`);
                                        window.scrollTo({ top: 0, behavior: "instant" });
                                    }}
                                >
                                    Check Eligibilty
                                </button>
                                <button
                                    className="explore-btn"
                                    onClick={() => {
                                        navigate(`/abroad-education-loan-overview`);
                                        window.scrollTo({ top: 0, behavior: "instant" });
                                    }}
                                >
                                    Explore Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselCaptions" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselCaptions" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
            {/* Card Section */}
            <div className="container">
                <div className="row">
                    {cards.map((card, idx) => (
                        <div className="col-md-3">
                            <div className="card-box">
                                <div className="mb-3">
                                    <img src={card.img} alt="Education Icon" className="img-fluid" />
                                </div>
                                <h5 className="card-title">{card.head}</h5>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* About Section */}
            <section class="about-bg">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="images/about.png" alt="about-img" class="img-fluid" />
                        </div>
                        <div class="col-md-6 d-block my-auto">
                            <h5 className="about-head">// About Us</h5>
                            <h3 class="general-head">Welcome to Credere </h3>
                            <p class="mb-4 general-des">Are you facing difficulties in overcoming financial obstacles to achieve your educational aspirations? If so, you have arrived at the ideal place! Credere aims to support your dream of attaining a high- quality education.<br /><br />
                                Our platform assists students in discovering and comparing education loans from different lenders. We have created an easy and clear process that enables students to secure the most suitable loan for their requirements.</p>
                            <div className="about-btn">
                                <button className="loan-btn" 
                                    onClick={() => {
                                        navigate(`/about-us`);
                                        window.scrollTo({ top: 0, behavior: "instant" });
                                    }}
                                >Read More</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Loan Section */}
            <section className="loan-check">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 loan-detail">
                            <h5>// Check Loan Eligibility</h5>
                            <h2>Get the Best Education Loan to Study Abroad</h2>
                            <p>25,000+ Abroad Education Loans Sanctioned! 8,000+ Crores Disbursed!</p>
                            <ul className="loan-li">
                                <li>1. An well experienced IT services & solution provider</li>
                                <li>2. Backed up by a highly talented and knowledgeable team</li>
                                <li>3. 100% resilient, and stable IT infrastructure available</li>
                            </ul>
                        </div>
                        <div className="col-md-6 mt-2 mb-2">
                            <form className="loan-check-form" onSubmit={handleLoanFormSubmit}>
                                <h4>Fill in the Details Below</h4>
                                {loanFormSuccess && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                {loanFormError && <div className="alert alert-danger mt-2">{loanFormError}</div>}
                                <div className="row">
                                    {loanFormStep === 1 && (
                                        <>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Name <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. Priya Senger"
                                                    name="name"
                                                    value={loanForm.name}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.name && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.name}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Email <span>*</span></label>
                                                <input
                                                    type="email"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. priya@doe.com"
                                                    name="email"
                                                    value={loanForm.email}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.email && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.email}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Applicant City of Residence <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. New Delhi"
                                                    name="city"
                                                    value={loanForm.city}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.city && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.city}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Phone <span>*</span></label>
                                                <input
                                                    type="tel"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. 8888880000"
                                                    name="phone"
                                                    value={loanForm.phone}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                    maxLength={10}
                                                />
                                                {loanFormErrors.phone && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.phone}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Gender <span>*</span></label><br />
                                                <div className="d-flex">
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="gender" value="Male"
                                                            checked={loanForm.gender === "Male"}
                                                            onChange={() => handleLoanFormRadio("gender", "Male")}
                                                        />
                                                        <label htmlFor="male" className="radio-label">Male</label>
                                                    </div>
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="gender" value="Female"
                                                            checked={loanForm.gender === "Female"}
                                                            onChange={() => handleLoanFormRadio("gender", "Female")}
                                                        />
                                                        <label htmlFor="female" className="radio-label">Female</label>
                                                    </div>
                                                    <div className="">
                                                        <input type="radio" className="form-check-input finance-radio" name="gender" value="Other"
                                                            checked={loanForm.gender === "Other"}
                                                            onChange={() => handleLoanFormRadio("gender", "Other")}
                                                        />
                                                        <label htmlFor="other" className="radio-label">Other</label>
                                                    </div>
                                                </div>
                                                {loanFormErrors.gender && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.gender}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Is the above number on Whatsapp? <span>*</span></label><br />
                                                <div className="d-flex">
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="whatsapp" value="Yes"
                                                            checked={loanForm.whatsapp === "Yes"}
                                                            onChange={() => handleLoanFormRadio("whatsapp", "Yes")}
                                                        />
                                                        <label htmlFor="whatsapp-yes" className="radio-label">Yes</label>
                                                    </div>
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="whatsapp" value="No"
                                                            checked={loanForm.whatsapp === "No"}
                                                            onChange={() => handleLoanFormRadio("whatsapp", "No")}
                                                        />
                                                        <label htmlFor="whatsapp-no" className="radio-label">No</label>
                                                    </div>
                                                </div>
                                                {loanFormErrors.whatsapp && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.whatsapp}</div>}
                                            </div>
                                            {loanForm.whatsapp === "No" && (
                                                <div className="col-md-12 finance-head-form">
                                                    <label className="form-label finance-label">Whatsapp Number <span>*</span></label>
                                                    <input
                                                        type="tel"
                                                        className="form-control finance-input"
                                                        placeholder="E.g. 8908098988"
                                                        name="altWhatsapp"
                                                        value={loanForm.altWhatsapp}
                                                        onChange={handleLoanFormChange}
                                                        required
                                                        maxLength={10}
                                                    />
                                                    {loanFormErrors.altWhatsapp && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.altWhatsapp}</div>}
                                                </div>
                                            )}
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Do you have an Admit? <span>*</span></label><br />
                                                <div className="d-flex">
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="admit" value="Yes"
                                                            checked={loanForm.admit === "Yes"}
                                                            onChange={() => handleLoanFormRadio("admit", "Yes")}
                                                        />
                                                        <label htmlFor="admit-yes" className="radio-label">Yes</label>
                                                    </div>
                                                    <div className="me-3">
                                                        <input type="radio" className="form-check-input finance-radio" name="admit" value="No"
                                                            checked={loanForm.admit === "No"}
                                                            onChange={() => handleLoanFormRadio("admit", "No")}
                                                        />
                                                        <label htmlFor="admit-no" className="radio-label">No</label>
                                                    </div>
                                                </div>
                                                {loanFormErrors.admit && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.admit}</div>}
                                            </div>
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="loan-btn w-100 mt-3"
                                                    onClick={() => {
                                                        // Validate only step 1 fields
                                                        const errors = {};
                                                        if (!loanForm.name.trim() || !/^[a-zA-Z\s]+$/.test(loanForm.name)) {
                                                            errors.name = "Name is required and should contain only letters and spaces.";
                                                        }
                                                        if (!loanForm.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loanForm.email)) {
                                                            errors.email = "Valid email is required.";
                                                        }
                                                        if (!loanForm.city.trim()) {
                                                            errors.city = "City is required.";
                                                        }
                                                        if (!/^\d{10}$/.test(loanForm.phone)) {
                                                            errors.phone = "Phone must be exactly 10 digits.";
                                                        }
                                                        if (!loanForm.gender) {
                                                            errors.gender = "Gender is required.";
                                                        }
                                                        if (!loanForm.whatsapp) {
                                                            errors.whatsapp = "Whatsapp selection is required.";
                                                        }
                                                        if (loanForm.whatsapp === "No" && !/^\d{10}$/.test(loanForm.altWhatsapp)) {
                                                            errors.altWhatsapp = "Alternate Whatsapp number must be exactly 10 digits.";
                                                        }
                                                        if (!loanForm.admit) {
                                                            errors.admit = "Admit selection is required.";
                                                        }
                                                        setLoanFormErrors(errors);
                                                        if (Object.keys(errors).length === 0) {
                                                            setLoanFormStep(2);
                                                        }
                                                    }}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </>
                                    )}
                                    {loanFormStep === 2 && (
                                        <>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Tentative Course Start Year  <span>*</span></label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseYear"
                                                    value={loanForm.courseYear}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                >
                                                    <option value="" disabled>Select Year</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2027">2027</option>
                                                    <option value="2028">2028</option>
                                                </select>
                                                {loanFormErrors.courseYear && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseYear}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Tentative Course Start Month  <span>*</span></label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseMonth"
                                                    value={loanForm.courseMonth}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="January">January</option>
                                                    <option value="Febuary">Febuary</option>
                                                    <option value="March">March</option>
                                                    <option value="April">April</option>
                                                    <option value="May">May</option>
                                                    <option value="June">June</option>
                                                    <option value="July">July</option>
                                                    <option value="August">August</option>
                                                    <option value="September">September</option>
                                                    <option value="October">October</option>
                                                    <option value="November">November</option>
                                                    <option value="December">December</option>
                                                </select>
                                                {loanFormErrors.courseMonth && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseMonth}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Course Level   <span>*</span></label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseLevel"
                                                    value={loanForm.courseLevel}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="Masters">Masters</option>
                                                    <option value="Under Graduate">Under Graduate</option>
                                                    <option value="PG Diploma">PG Diploma</option>
                                                    <option value="UG Diploma">UG Diploma</option>
                                                    <option value="PhD">PhD</option>
                                                </select>
                                                {loanFormErrors.courseLevel && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseLevel}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Course Degree <span>*</span></label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="courseDegree"
                                                    value={loanForm.courseDegree}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="BTech">BTech</option>
                                                    <option value="MTech">MTech</option>
                                                    <option value="MBA">MBA</option>
                                                    <option value="MS">MS</option>
                                                </select>
                                                {loanFormErrors.courseDegree && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseDegree}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Course Name <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="Master in Computer Science"
                                                    name="courseName"
                                                    value={loanForm.courseName}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.courseName && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.courseName}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target Country <span>*</span></label>
                                                <select
                                                    className="form-select finance-input"
                                                    name="TCountry"
                                                    value={loanForm.TCountry}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                >
                                                    <option value="" disabled>Please Select</option>
                                                    <option value="USA">USA</option>
                                                    <option value="Canada">Canada</option>
                                                    <option value="UK">UK</option>
                                                    <option value="Australia">Australia</option>
                                                </select>
                                                {loanFormErrors.TCountry && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.TCountry}</div>}
                                            </div>
                                            <div className="col-md-12 finance-head-form">
                                                <label className="form-label finance-label">Target College/University <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control finance-input"
                                                    placeholder="E.g. University of Canada"
                                                    name="college"
                                                    value={loanForm.college}
                                                    onChange={handleLoanFormChange}
                                                    required
                                                />
                                                {loanFormErrors.college && <div className="text-danger" style={{ fontSize: "0.9em" }}>{loanFormErrors.college}</div>}
                                            </div>
                                            <div className="col-12 d-flex justify-content-between">
                                                <button type="button" className="partner-btn ms-0 w-50 me-2 mt-3" onClick={() => setLoanFormStep(1)}>Back</button>
                                                <button type="submit" className="loan-btn w-50 ms-2 mt-3" disabled={loanFormLoading}>
                                                    {loanFormLoading ? "Submitting..." : "Submit"}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            {/* About Section */}
            <section class="about-bg">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 d-block my-auto">
                            <h5 className="about-head">// Why Choose Us</h5>
                            <h3 class="general-head">Make your education loan journey simple </h3>
                            <p class="mb-4 general-des">Credere Finance is more than just a platform; it serves as a connection between ambition and success. Our purpose is simple to provide students with easy access to personalized educational finance alternatives. We understand that each students educational journey is distinctive, which is why we provide several solutions to match various needs and ambitions.</p>
                            <div className="d-flex mb-4">
                                <div className="header-icon-box-wrapper">

                                    <div className="header-icon-box">

                                        <img src="images/award-winning-icon.png" alt="" className="" />
                                    </div>

                                    <div className="header-icon-box-content">

                                        <h6 className="header-icon-box-title mb-0" style={{ color: "var(--primarycolor)" }}>

                                            Award Winning
                                        </h6>

                                        <p className="header-icon-box-description mb-0" style={{
                                            fontSize: "15px", lineHeight: "20px", fontWeight: "500"

                                        }}>
                                            Finance categories winning more than 10 awards			</p>

                                    </div>

                                </div>
                                <div className="header-icon-box-wrapper">

                                    <div className="header-icon-box">
                                        <img src="images/certified-company-icon.png" alt="Certified Company" className="header-icon" />
                                    </div>

                                    <div className="header-icon-box-content">

                                        <h6 className="header-icon-box-title mb-0" style={{ color: "var(--primarycolor)" }}>
                                            Certified Company
                                        </h6>

                                        <p className="header-icon-box-description mb-0" style={{
                                            fontSize: "15px", lineHeight: "20px", fontWeight: "500"

                                        }}>
                                            Approved Finance company to provide loans	</p>

                                    </div>

                                </div>
                            </div>
                            <div className="about-btn">
                                <button className="loan-btn" onClick={() => {
                                        navigate(`/overview`);
                                        window.scrollTo({ top: 0, behavior: "instant" });
                                    }}>Read More</button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <img src="images/choose.png" alt="about-img" class="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>
            {/*Our Landing Partners Section */}
            <section className="landing-partners">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="about-head mb-5 text-center">Our Landing Partners</h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 mb-4">
                            <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 mb-4">
                            <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>
            {/*Study Abroad*/}
            <section className="study-abroad">
                <div className="container">
                    <div className="row">
                        <h5 className="about-head text-center mb-5" style={{ color: "var(--primarycolor)", fontWeight: "700" }}>Study Abroad</h5>
                        {courses.map((course, idx) => (
                            <div className="col-md-3">
                                <div className="study-abroad-card">
                                    <img src={course.img} alt="Study Abroad Icon" className="img-fluid" />
                                    <div className="study-abroad-content">
                                        <div className="study-abroad-head-box">
                                            <h5 className="study-abroad-head">{course.head}</h5>
                                            <button className="partner-btn ">Read More</button>
                                        </div>
                                    </div>

                                </div>
                            </div>))}
                    </div>
                </div>
            </section>
            {/*Education for All Section */}
            <section className="education-for-all">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-block my-auto">
                            <h5 className="about-head">// Our Aim is Seamless</h5>
                            <h3 className="general-head">Education for All</h3>
                            <p className="mb-4 general-des">Your trusted financial partner</p>
                            <div className="about-btn">
                                <button
                                    className="partner-btn ms-0 me-2"
                                    onClick={() => {
                                        navigate(`/check-loan-eligibility`);
                                        window.scrollTo({ top: 0, behavior: "instant" });
                                    }}
                                >
                                    Check Loan Eligibilty
                                </button>
                                {/* <button className="partner-btn ms-0 ms-2">Calculate Loan EMIs</button> */}
                            </div>
                        </div>
                        <div className="col-md-6 mt-5">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="edcuation-card">
                                        <CurrencyExchangeIcon className="edu-card-icon" />
                                        <h2>5000+</h2>
                                        <h5>Education Loans Provided</h5>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="edcuation-card">
                                        <RealEstateAgentIcon className="edu-card-icon" />
                                        <h2>₹1,250+Cr</h2>
                                        <h5>Loan Amount Disbursed</h5>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="edcuation-card">
                                        <SchoolIcon className="edu-card-icon" />
                                        <h2>340+</h2>
                                        <h5>Supported Universities</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Client Feedback Slider Section */}
            {/* <section className="client-feedback-slider">
                <div className="container">
                    <div className="row">
                        <h5 className="about-head text-center mb-5" style={{ color: "var(--primarycolor)", fontWeight: "500" }}>Client Feedback & Reviews</h5>
                        <div className="col-md-8 d-block mx-auto">
                            <FeedbackSlider />
                        </div>
                    </div>
                </div>

                <div>

                </div>
            </section > */}
            {/* Blog Section */}
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="about-head text-center mb-5" style={{ color: "var(--primarycolor)", fontWeight: "500" }}>Know More About The Credere Article</h5>
                        </div>
                        {blogs.map((item, idx) => {
                                    // Map index to a unique string for the route
                                    const blogRoutes = ["blogdescription", "blogdescriptionTwo", "blogdescriptionThree"];
                                    const blogRoute = blogRoutes[idx] || `blogdescription${idx+1}`;
                                    return (
                                        <div className="col-md-4 mb-4" key={idx}>
                                            <div className="blog-card">
                                                <img src={item.img} alt="Blog Image" className="img-fluid" />
                                                <div className="blog-content">
                                                    <h5 className="blog-head">{item.head}</h5>
                                                    <p className="blog-des">{item.des}</p>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <button
                                                            className="partner-btn ms-0"
                                                            onClick={() => {
                                                                navigate(`/${blogRoute}`);
                                                                window.scrollTo({ top: 0, behavior: "instant" });
                                                            }}
                                                        >
                                                            Read More
                                                        </button>
                                                        {/* <ul className="blog-icon-list">
                                                            <li><i className="fa fa-calendar"></i><a href=""><Person3Icon /> Admin</a></li>
                                                            <li><i className="fa fa-user"></i><a href=""><ForumIcon /> No Comments</a></li>
                                                        </ul> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;